import { GESTION_OPERATIVA_GET_PRECIOS } from './constants'
import { bonifications } from '@asofix/core'

export function getPrecios() {
  return (dispatch, getState) => {
    const { gestionOperativa } = getState()
    const { sale } = gestionOperativa

    const {
      total: precioTotal,
      subTotal: precioSubTotal,
      carlotBonification: bonificacionConcesionaria
    } = bonifications.calculateSaleTotal(sale)

    return dispatch({
      type: GESTION_OPERATIVA_GET_PRECIOS,
      data: {
        bonificacionConcesionaria,
        precioSubTotal,
        precioTotal
      }
    })
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_GET_PRECIOS) {
      // Just after a request is sent
      return {
        ...state,
        sale: {
          ...state.sale,
          bonificacionConcesionaria: action.data.bonificacionConcesionaria,
          precioSubTotal: action.data.precioSubTotal,
          precioTotal: action.data.precioTotal
        }
      }
  }
  else {
    return state
  }    
}